import axios from 'axios'
import store from '../store'
import config from '../config'

const http = axios.create({
  baseURL: String(config.mainApi).trim(),
  headers: {
    'Content-Type': 'application/json'
  }
})

http.interceptors.request.use(request => {
  request.headers.Authorization = `Bearer ${store.state.token}`
  return Promise.resolve(request)
})

http.interceptors.response.use(
  response => response,
  error => {
    console.log({error})
    const { status } = error.response
    if (status === 401) {
      store.commit('setLogout')
    }
    return Promise.reject(error)
  }
)

export default http
